(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-store-utilities"] && !Shopify.designMode) return;
  try {
    
(function () {
  function prepareMainContent() {
    var main = document.getElementById('MainContent');
    if (main && !main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareMainContent, { once: true });
  } else {
    prepareMainContent();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gs-slideshow-guard')) {
  customElements.define('gs-slideshow-guard', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionHandled = false;
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
      this.addEventListener('focusin', (event) => {
        if (!event.target.closest('.slideshow__pause')) this.pause();
      }, {signal: this.abort.signal});
      this.motion.addEventListener('change', () => {
        this.motionHandled = false;
        this.sync();
      }, {signal: this.abort.signal});
      this.sync();
    }
    pause() {
      const hero = this.querySelector('.hero');
      const button = this.querySelector('.slideshow__pause');
      if (hero?.classList.contains('flickity-enabled') && hero.dataset.autoplay === 'true' && button && !button.classList.contains('is-paused')) button.click();
    }
    sync() {
      const hero = this.querySelector('.hero');
      if (!hero) return;
      const slides = Array.from(hero.querySelectorAll('.slideshow__slide'));
      const selected = hero.querySelector('.slideshow__slide.is-selected') || slides[0];
      for (const slide of slides) {
        const inactive = slide !== selected;
        if (inactive && slide.contains(document.activeElement)) this.querySelector('.slideshow__pause')?.focus({preventScroll: true});
        slide.inert = inactive;
        slide.setAttribute('aria-hidden', String(inactive));
      }
      if (hero.classList.contains('flickity-enabled') && this.motion.matches && !this.motionHandled) {
        this.motionHandled = true;
        this.pause();
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
